import { h, hydrate } from "preact";
import type { ArchiveHydrationData } from "../../summary/archive-view.js";
import { PageInfo, PageInfoContext } from "../../core/page-info.js";
import { HYDRATION_DATA_ID } from "../../../gen/view/html-skeleton.js";
import { ArchiveViewCore, HYDRATION_ROOT } from "./simple-archive-view.js";

const scriptElement = document.getElementById(HYDRATION_DATA_ID);
if (! (scriptElement instanceof HTMLScriptElement)) {
  throw new Error();
}
const hydrationDataStr = scriptElement.text;
const hydrationData: ArchiveHydrationData = JSON.parse(hydrationDataStr);
const pageInfo = PageInfo.fromJson(hydrationData.pageInfoJson);
const vnodeWithContext = (
  <PageInfoContext.Provider value={pageInfo}>
    <ArchiveViewCore pageHeadingHtml={hydrationData.pageHeadingHtml} itemsPerPage={hydrationData.itemsPerPage} />
  </PageInfoContext.Provider>
);

const hydrationRoot = document.getElementById(HYDRATION_ROOT);
if (hydrationRoot === null) {
  throw new Error();
}

hydrate(vnodeWithContext, hydrationRoot);
